import { Link } from 'react-router-dom';
import { Helmet } from '@dr.pogodin/react-helmet';

export default function SmsConsent() {
  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(to bottom, #f8fafc, white)', fontFamily: 'system-ui, -apple-system, sans-serif' }}>
      <Helmet>
        <title>SMS Consent & Opt-In | Atomic Tattoo Removal</title>
        <meta name="description" content="How clients opt in to SMS appointment reminders at Atomic Tattoo Removal, including a screenshot of the intake form consent checkbox and disclosures." />
      </Helmet>

      {/* Minimal nav */}
      <header style={{ background: 'rgba(255,255,255,0.9)', backdropFilter: 'blur(12px)', borderBottom: '1px solid #f1f5f9', position: 'sticky', top: 0, zIndex: 50 }}>
        <div style={{ maxWidth: '72rem', margin: '0 auto', padding: '0 1.5rem', height: '4rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontWeight: 700, fontSize: '1.125rem', color: '#1e293b', textDecoration: 'none' }}>
            Atomic Tattoo Removal
          </Link>
          <Link
            to="/"
            style={{ fontSize: '0.875rem', color: '#64748b', textDecoration: 'none' }}
          >
            &larr; Back to Home
          </Link>
        </div>
      </header>

      <div style={{ maxWidth: '72rem', margin: '0 auto', padding: '4rem 1.5rem' }}>
        {/* Page header */}
        <div style={{ marginBottom: '3rem', maxWidth: '42rem' }}>
          <span style={{ display: 'inline-block', fontSize: '0.75rem', fontWeight: 600, letterSpacing: '0.1em', color: '#6366f1', textTransform: 'uppercase', marginBottom: '0.75rem' }}>
            Legal
          </span>
          <h1 style={{ fontSize: '2.25rem', fontWeight: 700, color: '#1e293b', marginBottom: '1rem', lineHeight: 1.2 }}>
            SMS Consent &amp; Opt-In
          </h1>
          <p style={{ marginTop: '1rem', color: '#64748b', fontSize: '1rem', lineHeight: 1.7 }}>
            Atomic Tattoo Removal sends SMS appointment reminders only to clients who opt in. Clients opt
            in by checking the "Subscribe to SMS Appointment Reminders" box on our patient intake form when
            booking an appointment. The checkbox is not pre-selected. Below is a screenshot of the opt-in
            section of our intake form, including the consent checkbox and required disclosures.
          </p>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '4rem' }}>
          {/* Main content */}
          <main style={{ maxWidth: '50rem' }}>
            {/* Intake form screenshot */}
            <img
              src="/assets/intake.png"
              alt="Atomic Tattoo Removal patient intake form showing the Subscribe to SMS Appointment Reminders opt-in checkbox and SMS disclosures"
              style={{
                display: 'block',
                width: '100%',
                maxWidth: '800px',
                height: 'auto',
                margin: '0 auto',
                borderRadius: '0.75rem',
                border: '1px solid #e2e8f0',
                boxShadow: '0 6px 24px rgba(30,58,95,0.10)',
              }}
            />

            <p style={{ marginTop: '2rem', color: '#64748b', lineHeight: 1.7 }}>
              The intake form discloses that message frequency varies and that message and data rates may
              apply, provides HELP and STOP instructions, states that mobile numbers are not shared with third
              parties for marketing, and links to our Privacy Policy and Terms and Conditions. For questions,
              contact{' '}
              <a
                href="mailto:craig@atomictattooremoval.com"
                style={{ color: '#6366f1', textDecoration: 'underline' }}
              >
                craig@atomictattooremoval.com
              </a>
              .
            </p>

            <p style={{ marginTop: '1.5rem', color: '#64748b', lineHeight: 1.7 }}>
              See our{' '}
              <Link to="/privacy-policy" style={{ color: '#6366f1', textDecoration: 'underline' }}>
                Privacy Policy
              </Link>{' '}
              and{' '}
              <Link to="/terms-and-conditions" style={{ color: '#6366f1', textDecoration: 'underline' }}>
                Terms and Conditions
              </Link>
              .
            </p>

            {/* Bottom divider */}
            <div style={{ marginTop: '3rem', paddingTop: '1.5rem', borderTop: '1px solid #f1f5f9', fontSize: '0.75rem', color: '#cbd5e1' }}>
              &copy; {new Date().getFullYear()} Atomic Tattoo Removal. All rights reserved.
            </div>
          </main>
        </div>
      </div>
    </div>
  )
}
